
import { Component, Vue, Prop } from 'vue-property-decorator'
import CharField from '../fields/CharField.vue'
import IbanField from '../fields/IbanField.vue'
import axios from 'axios'
import { IPSBankAccountForm } from '@/types/processingSteps'
import HdsCheckboxCross from '../fields/HdsCheckboxCross.vue'

@Component({
  components: {
    CharField,
    IbanField,
    HdsCheckboxCross
  }
})
export default class PSBankAccountForm extends Vue {
  @Prop() bankAccountForm!: IPSBankAccountForm
  @Prop() bankAccountFormErrors!: IPSBankAccountForm
  @Prop(({ default: false })) readOnly!: boolean

  private initialForm: IPSBankAccountForm

  mounted() {
    this.initialForm = {
      owner: this.bankAccountForm.owner,
      bank_name: this.bankAccountForm.bank_name,
      iban: this.bankAccountForm.iban,
      bic: "", // BIC cannot change without IBAN changing
      termsAccepted: this.bankAccountForm.termsAccepted
    }
  }

  async fetchIban (): Promise<void> {
    const iban = this.bankAccountForm.iban.replace(/\s/g, '')
    if (!iban || iban.length < 15) {
      return
    }
    const url = "/api/v4/iban/" + iban + "/"
    await axios.get(url).then((response) => {
      this.bankAccountForm.bic = response.data.bic
    }).catch(() => {
      this.$emit("iban-not-found")
    })
  }

  onBankInfoChanged() {
    this.bankAccountForm.termsAccepted = (
      this.initialForm.termsAccepted && // Only check if it was previously accepted
      this.initialForm.owner === this.bankAccountForm.owner &&
      this.initialForm.bank_name === this.bankAccountForm.bank_name &&
      this.initialForm.iban === this.bankAccountForm.iban
    )
  }
}
